import React from 'react';

import Statistics from '~/Components/Statistics/Statistics';
import StatisticsHeader from '~/Components/StatisticsHeader/StatisticsHeader';
import { getStatisticsData, getStatisticsHeaderData } from '~/utils/statistics';

import styles from './DetailInfo.scss';

export interface DetailInfo_Props {
  statistics: BattleStat;
  seasonsAndBestRanksData?: SeasonBestRankInfo[];
  seasonsAndBestRatingData?: SeasonBestRatingInfo[];
  seasonNumber?: string | number;
}

const DetailInfo = ({
  statistics,
  seasonsAndBestRanksData,
  seasonsAndBestRatingData,
  seasonNumber,
}: DetailInfo_Props) => {
  const statisticData = getStatisticsHeaderData(
    statistics,
    seasonsAndBestRanksData,
    seasonsAndBestRatingData,
    seasonNumber,
  );

  return (
    <div className={styles.wrapper}>
      <StatisticsHeader data={statisticData} />
      <Statistics data={getStatisticsData(statistics)} />
    </div>
  );
};

export default DetailInfo;
